import React, { Component } from "react";
import addIconUrl from '@deere/ux.brand-foundations/icons/add.svg';
import { Card } from '@deere/ux.uxframe-react';
import FinacialSummary from './finacial-summary.jsx';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

if (isMobile) {
    import('../mobileindex.css').then(() => {});
} else {
    import('../company/components/scss/index.css').then(() => {});
}

class FinacialComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosNumber: this.props.companyInfoObj.prosNumber
        };
    }
    render() {
        return (
            <div>
                <h3 class="component-section-title">Financial Information</h3>
                {this.props.displayFinacialInfo === true ?
                    <Card>
                        <div class="card-body">
                            <FinacialSummary finacialInfoData={this.props.finacialInfo} companyInfoObjFIN={this.props.companyInfoObj} />
                        </div>
                    </Card> :
                    <Link to={"/diversity-finacial-info/" + this.state.prosNumber} className="linkContainerStyle"><Card>
                        <img src={addIconUrl} style={{ alignSelf: 'center', height: 260, width: 350 }} />
                        <label class="uxf-label">Add Financial Information</label>
                    </Card></Link>
                }
            </div>
        )
    }
}
export default FinacialComponent;